export default "__VITE_ASSET__$TdRfY9l__"